import { ExpenseClassification } from "../../generated/domain-models/enums/generated-expense-classification";
import { ExpenseSelectionViewModel } from "../../view-models/expense-selection.view-model";
import { ReceiptParamsViewModel } from "../../view-models/receipt-params.view-model";
import { RECEIPT_STEPS } from "../receipt-steps.service";
import { AccommodationDataState } from "./accommodation-data-state";
import { BaseState } from "./base-state";
import { ExpenseModelDataState } from "./expense-model-data-state";
import { FoodDataState } from "./food-data-state";
import { MileageRefoundDataState } from "./mileage-refound-data-state";
import { OtherDataState } from "./other-data-state";
import { StepStateInterface } from "./step-state.interface";
import { TransportDataState } from "./transport-data-state";

export class ExpenseSelectionState extends BaseState implements StepStateInterface {
  ClassConstructor = ExpenseSelectionState;
  property = 'expenseSelection';
  slug = RECEIPT_STEPS.expenseClassification;

  async previous(context: any): Promise<StepStateInterface> {

    const viewModel = context.data[context.state.property] as ExpenseSelectionViewModel;
    return new ExpenseModelDataState();
  }
  async next(context: any): Promise<StepStateInterface> {
    const viewModel = context.data[context.state.property] as ExpenseSelectionViewModel;
    const expenseData = (viewModel.parent as ReceiptParamsViewModel).expenseData;

    if (expenseData.isLastStep()) {
      return null;
    }

    switch (expenseData.currentExpenseClassificationType) {
      case ExpenseClassification.Food:
        return new FoodDataState();
      case ExpenseClassification.Accommodation:
        return new AccommodationDataState();
      case ExpenseClassification.MileageRefound:
        return new MileageRefoundDataState();
      case ExpenseClassification.Other:
        return new OtherDataState();
      case ExpenseClassification.Transport:
        return new TransportDataState();
      case ExpenseClassification.Accommodation:
        return new AccommodationDataState();
      default:
        return new FoodDataState();
    }
  }


}
